module.exports = __webpack_public_path__ + "static/media/img-lawyer-mobile.e4d7e3fe.jpg";